export default "__VITE_ASSET__D6DutF4v__"